import { useState } from 'react';import IcoLayer from '../../images/ico_layers.svg';
import { Checkbox, Popover, Badge, Tooltip } from 'antd';

import { useAuth } from '../Auth/store';
import { Button as CustomButton } from '../Buttons/button';
import References from '../../helpers/Reference';
import { ArrayToggle } from '../../helpers/helpers';

import { PrecipitationFieldsPlayer } from './precipitation.field/precipitation.fields.player';
import { WaterLevel } from './water.level/water.level';

import { useLayers } from './store';
import { Precipitation } from './precipitation/precipitation';

import { calcBtnLayerBottomPos } from './helpers';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { HelperContext } from '../Helper/helper.context';
import { helpContextResponsive } from '../Helper/utils';

import ImgScreen1 from '../../images/help_context/field_precipitation_1.png';
import ImgScreen2 from '../../images/help_context/field_precipitation_2.png';

import Carousel from 'react-multi-carousel';

const DEFAULT_ACTIVE = 'station'

export const Layers = ({mapRef}) => {

    const { permission } = useAuth();    

    const [ opened, setOpened ] = useState( false );    
    const [ openedTooltip, setOpenedTooltip ] = useState( null )
    const [ layers, setLayers ] = useState([]);
    const [ active, setActive ] = useState(DEFAULT_ACTIVE);
    const [ btnLayerBottomPos, setBtnLayerBottomPos] = useState(0);

    const [ isShowHelperContext, setIsShowHelperContext ] = useState(false);

    const {leafLetLayers} = useLayers();

    const   onOpenChange = (newOpened) => {
        setOpened(newOpened);
        setOpenedTooltip(false);
    };    
    
    const onTooltipOpenChange = (newOpen) => {
        setOpenedTooltip(newOpen);
    };    

    const onChange = (e) => {        
        const newLayersArr = ArrayToggle(layers, e.target.value);
        if (newLayersArr.length > layers)
            setActive(e.target.value)
        else if (layers.length > 0)
            setActive(layers[layers.length - 1]);        
        else
            setActive(DEFAULT_ACTIVE);
        setLayers([...newLayersArr]);
        setBtnLayerBottomPos( calcBtnLayerBottomPos(e.target.checked, e.target.value) );        
    }

    const onToTopClick = (toTopLayer) => {
        mapRef.current._panes["stationMarkers"].style.zIndex = toTopLayer === 'station' ? 400 : 300;
        setActive(toTopLayer);        
        setBtnLayerBottomPos(calcBtnLayerBottomPos(true, toTopLayer, btnLayerBottomPos));        
        if (layers.indexOf(toTopLayer) === -1 && toTopLayer !== DEFAULT_ACTIVE) {
            let newLayers = layers;
            newLayers.push(toTopLayer);
            setLayers([...newLayers]);
        }        
    }

    const onShowHelperContext = () => {
        setIsShowHelperContext(true)
    }

    const onCloseHelperContext = () => {
        setIsShowHelperContext(false)
    }

    const onCloseLayersMenu = () => {
        setOpened(false)
    }

    const layersContent = () => {
        return (
        <>
            <div className="layers-close-padding">
                <span className="close" onClick={onCloseLayersMenu}>&times;</span>
            </div> 
            <div className="mt-1">
            {Object.keys(References.layers).map(key => {
            return (                
                <div key={`layers_checkbox_${key}`} className={`pv-1 borderb-eee d-flex layers-item${key === active ? ' active' : ''}`}>
                <Checkbox 
                    value={key} 
                    onChange={onChange}
                    checked={ layers.indexOf(key) !== -1 }
                ></Checkbox>
                    <div className="ml-1 cursor-pointer" onClick={() => onToTopClick(key)}>
                        {References.layers[key].title}
                    </div>
                </div>  
            )
            })}
                <div key="layers_checkbox_stations" className={`pv-1 d-flex layers-item${active === DEFAULT_ACTIVE ? ' active' : ''}`}>
                    <div className="ml-3 cursor-pointer" onClick={() => onToTopClick(DEFAULT_ACTIVE)}>
                        {References.dictionary.stations}
                    </div>
                </div>  
            </div>            
        </>
        )      
    }

    if (permission?.permissions?.hasOwnProperty('can_view_geo_data') && permission.permissions.can_view_geo_data === false)
        return <></>

    return (   
        <>
            {isShowHelperContext &&

                <HelperContext 
                onClose={onCloseHelperContext}
                children={
                    <div className="help-context-wrapper">
                        <Carousel
                            className="help-context-carousel"
                            responsive={helpContextResponsive}
                        >
                            <div className="help-context-item">
                                <img src={ImgScreen1}/>
                            </div>
                            <div className="help-context-item">
                                <img src={ImgScreen2}/>
                            </div>

                        </Carousel>
                    </div>
                }
                />

            }
            
            <div id="layers_manage" className="left-menu-items" style={{bottom: btnLayerBottomPos}}>

                <div onClick={onShowHelperContext} style={{position: "absolute", right: "2px", top: "2px", color: "#999", fontSize: "14px", cursor: "pointer"}} >
                    <QuestionCircleOutlined />
                </div>

                <Popover 
                    trigger="click"
                    open={opened}
                    onOpenChange={onOpenChange}
                    placement="topRight"                   
                    overlayClassName="popup-left-menu-padding-layers"
                    arrow={false}    
                    getPopupContainer={() => document.getElementById('layers_manage')}                    
                    content={layersContent} 
                >

                    <Tooltip
                        title={References.dictionary.tooltips.button_layers} 
                        open={openedTooltip} 
                        onOpenChange={onTooltipOpenChange}
                        placement="top"
                        color="white"
                        overlayInnerStyle={{color: "black"}}
                        mouseEnterDelay={References.tooltip_delay}
                    >
                    <div className="layers_manage_btn">
                        <Badge dot={true} size="small" count={layers.length} offset={[5, 0]}>
                        <span className="font">Слои</span>
                        </Badge>
                    </div>
                    </Tooltip>                                           

                </Popover>
            </div>             

            {layers.indexOf('prec_triangle') !== -1 &&
                <PrecipitationFieldsPlayer mapRef={mapRef} />
            }

            {layers.indexOf('prec') !== -1 &&
                <Precipitation mapRef={mapRef} />
            }        

            {layers.indexOf('water_level') !== -1 &&
                <WaterLevel mapRef={mapRef} />
            } 
        </>
    );
    
}
